"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_event_1 = require("./types.event");
exports.apiError = new types_event_1.TypedEvent();
var DataService = /** @class */ (function () {
    function DataService(http, urlService, transformator, idFieldName) {
        this.http = http;
        this.urlService = urlService;
        this.transformator = transformator;
        this.idFieldName = idFieldName;
        this.lastLists = new Map();
    }
    DataService.prototype.loadByReference = function (reference) {
        return this.load(reference.id);
    };
    DataService.prototype.load = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var object, _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = this.transformFromServerWrapper;
                        return [4 /*yield*/, this.loadItem(id)];
                    case 1: return [4 /*yield*/, _a.apply(this, [_b.sent()])];
                    case 2:
                        object = _b.sent();
                        return [2 /*return*/, object];
                    case 3:
                        error_1 = _b.sent();
                        exports.apiError.emit(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.loadItem = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var item, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.get(this.urlService.getLoadUrl(id), { withCredentials: true }).toPromise()];
                    case 1:
                        item = _a.sent();
                        return [2 /*return*/, item];
                    case 2:
                        error_2 = _a.sent();
                        exports.apiError.emit(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.save = function (object, exists) {
        if (exists === void 0) { exists = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, httpRequest, object_1, _a, error_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        object = this.transformator.transformToServer(object);
                        id = object[this.idFieldName];
                        httpRequest = !!id && exists
                            ? this.http.put(this.urlService.getUpdateUrl(id), object, { withCredentials: true })
                            : this.http.post(this.urlService.getSaveUrl(), object, { withCredentials: true });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        _a = this.transformFromServerWrapper;
                        return [4 /*yield*/, httpRequest.toPromise()];
                    case 2: return [4 /*yield*/, _a.apply(this, [_b.sent()])];
                    case 3:
                        object_1 = _b.sent();
                        return [2 /*return*/, object_1];
                    case 4:
                        error_3 = _b.sent();
                        exports.apiError.emit(error_3);
                        throw error_3;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.patch = function (object) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, httpRequest, object_2, _a, error_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        object = this.transformator.transformToServer(object);
                        id = object[this.idFieldName];
                        httpRequest = this.http.patch(this.urlService.getUpdateUrl(id), object, { withCredentials: true });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        _a = this.transformFromServerWrapper;
                        return [4 /*yield*/, httpRequest.toPromise()];
                    case 2: return [4 /*yield*/, _a.apply(this, [_b.sent()])];
                    case 3:
                        object_2 = _b.sent();
                        return [2 /*return*/, object_2];
                    case 4:
                        error_4 = _b.sent();
                        exports.apiError.emit(error_4);
                        throw error_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.updateField = function (id, fieldName, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpRequest;
            return tslib_1.__generator(this, function (_a) {
                httpRequest = this.http.post(this.urlService.getFieldUrl(id, fieldName), { value: value }, { withCredentials: true });
                try {
                    return [2 /*return*/, httpRequest.toPromise()];
                }
                catch (error) {
                    exports.apiError.emit(error);
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    DataService.prototype.transformFromServerWrapper = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.transformator.transformFromServer(data)];
            });
        });
    };
    DataService.prototype.createAll = function (objects) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serverObjects, httpRequest, storedObjects, error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serverObjects = objects.map(this.transformator.transformToServer.bind(this));
                        httpRequest = this.http.post(this.urlService.getSaveUrl(), serverObjects, { withCredentials: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, httpRequest.toPromise()];
                    case 2:
                        storedObjects = (_a.sent());
                        return [2 /*return*/, Promise.all(storedObjects
                                .map(this.transformFromServerWrapper.bind(this)))];
                    case 3:
                        error_5 = _a.sent();
                        exports.apiError.emit(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.saveFile = function (id, fieldName, file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData, httpRequest, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append(fieldName, file, file.name);
                        httpRequest = this.http.post(this.urlService.getFieldUrl(id, fieldName), formData, { withCredentials: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, httpRequest.toPromise()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        exports.apiError.emit(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.deleteFile = function (id, fieldName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpRequest, response, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpRequest = this.http.delete(this.urlService.getFieldUrl(id, fieldName), { withCredentials: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, httpRequest
                                .toPromise()];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_7 = _a.sent();
                        exports.apiError.emit(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.downloadFile = function (id, fieldName) {
        window.location = this.urlService.getFieldUrl(id, fieldName);
    };
    DataService.prototype.sanitizeFilters = function (params) {
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                if (params[key] === "") {
                    delete params[key];
                }
                if (params[key] === "_NULL_") {
                    params[key] = "";
                }
            }
        }
    };
    DataService.prototype.list = function (filters, callerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var lastList = _this.lastLists.get(callerId);
            if (!!lastList) {
                lastList.unsubscribe();
            }
            _this.sanitizeFilters(filters.params);
            var currentList = _this.http.get(_this.urlService.getListUrl(), { params: filters.params, withCredentials: true })
                .subscribe(function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var result, objects, objects;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            result = data;
                            if (!(result instanceof Array)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.transformObjectsFromServer(result)];
                        case 1:
                            objects = _a.sent();
                            result = {
                                page: objects,
                                total: objects.length
                            };
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.transformObjectsFromServer(result.page)];
                        case 3:
                            objects = _a.sent();
                            result = {
                                page: objects,
                                total: result.total
                            };
                            _a.label = 4;
                        case 4:
                            resolve(result);
                            return [2 /*return*/];
                    }
                });
            }); }, exports.apiError.emit);
            _this.lastLists.set(callerId, currentList);
        });
    };
    DataService.prototype.transformObjectsFromServer = function (page) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects, i, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        objects = [];
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < page.length)) return [3 /*break*/, 4];
                        _b = (_a = objects).push;
                        return [4 /*yield*/, this.transformFromServerWrapper(page[i])];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, objects];
                }
            });
        });
    };
    DataService.prototype.delete = function (object) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.delete(this.urlService.getDeleteUrl(object[this.idFieldName]), { withCredentials: true })
                                .toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_8 = _a.sent();
                        exports.apiError.emit(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.updateExcel = function (file) {
        var formData = new FormData();
        formData.append("file", file, file.name);
        var httpRequest = this.http.put(this.urlService.getExcelUrl(), formData, { withCredentials: true });
        return httpRequest
            .toPromise()
            .catch(function (e) { exports.apiError.emit(e); });
    };
    DataService.prototype.importExcel = function (file) {
        var formData = new FormData();
        formData.append("file", file, file.name);
        var httpRequest = this.http.post(this.urlService.getExcelUrl(), formData, { withCredentials: true });
        return httpRequest
            .toPromise()
            .catch(function (e) { exports.apiError.emit(e); });
    };
    DataService.prototype.exportExcel = function (params, allPages) {
        if (params === void 0) { params = undefined; }
        if (allPages === void 0) { allPages = true; }
        if (!!params) {
            this.sanitizeFilters(params);
            if (allPages) {
                delete params["_page"];
            }
        }
        window.location = this.urlService.getExcelUrl(params);
    };
    return DataService;
}());
exports.DataService = DataService;
//# sourceMappingURL=data.service.js.map